import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    z-index: 1;
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 2.5rem;
    width: 100vw;
    height: 100%;
    font-size: 9vw;
    font-weight: 700;
    background-color: #2400ff;
    animation: preloader-invisible 0.8s cubic-bezier(0.77, 0, 0.18, 1) 7s forwards;
    overflow: hidden;
`;

/* Separate element for background.webp so we can animate it independently */
const BackgroundImage = styled.div`
    position: absolute;
    top: -15%;
    left: -15%;
    width: 130%;
    height: 130%;
    background-image: url(${process.env.PUBLIC_URL}/img/background.webp);
    background-size: cover;
    background-position: center;
    pointer-events: none;
    z-index: 0;
    animation: bg-lines-drift 10s ease-in-out infinite;
`;

const LinesBackground = styled.div`
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 0;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background: repeating-linear-gradient(
            -45deg,
            transparent 0px,
            transparent 30px,
            rgba(255, 255, 255, 0.045) 30px,
            rgba(255, 255, 255, 0.045) 31px
        );
        background-size: 43.84px 43.84px;
        animation: lines-drift-slow 9s linear infinite;
    }

    &::after {
        content: '';
        position: absolute;
        inset: 0;
        background: repeating-linear-gradient(
            -45deg,
            transparent 0px,
            transparent 11px,
            rgba(255, 255, 255, 0.022) 11px,
            rgba(255, 255, 255, 0.022) 12px
        );
        background-size: 16.97px 16.97px;
        animation: lines-drift-fast 4s linear infinite;
    }
`;

const ScanLine = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    top: -140px;
    height: 140px;
    pointer-events: none;
    z-index: 0;
    background: linear-gradient(
        180deg,
        transparent 0%,
        rgba(255, 255, 255, 0.04) 30%,
        rgba(255, 255, 255, 0.1) 55%,
        rgba(255, 255, 255, 0.04) 80%,
        transparent 100%
    );
    animation: scan-sweep 3.8s ease-in-out 1s infinite;
`;

const Label = styled.span`
    position: relative;
    z-index: 1;
    font-size: 2.8vw;
    font-weight: 400;
    letter-spacing: 0.35em;
    text-transform: uppercase;
    opacity: 0;
    animation: preloader-visible 0.7s ease-out 0.3s forwards;
    margin-bottom: 1.5rem;
    color: rgba(255, 255, 255, 0.6);
`;

const Title = styled.p`
    position: relative;
    z-index: 1;
    margin: 0 0 0.2rem 0;
    line-height: 1.1;
    opacity: 0;
`;

const ProgressWrap = styled.div`
    position: absolute;
    z-index: 2;
    bottom: 3.5rem;
    left: 2.5rem;
    right: 2.5rem;
    height: 1px;
    background-color: rgba(255, 255, 255, 0.2);
    overflow: hidden;

    &::after {
        content: '';
        display: block;
        height: 100%;
        background-color: #ffffff;
        transform-origin: left center;
        transform: scaleX(0);
        animation: preloader-progress 6.6s cubic-bezier(0.4, 0, 0.6, 1) 0.5s forwards;
    }
`;

const Counter = styled.span`
    position: absolute;
    z-index: 2;
    bottom: 5rem;
    right: 2.5rem;
    font-size: 3vw;
    font-weight: 300;
    opacity: 0;
    animation: preloader-visible 0.6s ease-out 0.5s forwards;
    color: rgba(255, 255, 255, 0.5);
`;

const phrases = [
    'hello!',
    'karina kasimova',
    'frontend developer',
    'saint-petersburg',
];

const Preloader = () => {
    return (
        <Container>
            <BackgroundImage />
            <LinesBackground />
            <ScanLine />
            <Label>portfolio</Label>
            {phrases.map((phrase, i) => (
                <Title
                    key={'phrase_' + i}
                    style={{
                        fontWeight: i === 0 ? 900 : i === 1 ? 700 : 400,
                        fontSize: i === 0 ? '14vw' : i === 1 ? '10vw' : '7vw',
                        animation: `preloader-visible 0.7s cubic-bezier(0.23, 1, 0.32, 1) ${0.5 + i * 0.35}s forwards`,
                    }}
                >
                    {phrase}
                </Title>
            ))}
            <ProgressWrap />
            <Counter>2022</Counter>
        </Container>
    );
};

export default Preloader;
